import {Component, Input, OnInit} from '@angular/core';
import {FormControl} from "@angular/forms";
import {Filter} from "../../../../../search/search-list/filters/filter-block/filter-item/filter";
import {TranslateService} from "../../../../translate.service";
import {HtmlUtilsService} from "../../../../../html-utils/html-utils.service";
import {FiltersService} from "../../../../../search/search-list/filters/filters.service";
import {FilterRangeComponent} from "../../../../../search/search-list/filters/filter-block/filter-range/filter-range.component";
import {FacetRangeComponent} from '../facet-range/facet-range.component';
import {FacetService} from '../../facet.service';

@Component({
  selector: 'app-facet-range-quick-select',
  templateUrl: './facet-range-quick-select.component.html',
  styleUrls: ['./facet-range-quick-select.component.scss', '../facet-range/facet-range.component.scss','../facet-select/facet-select.component.scss']
})
export class FacetRangeQuickSelectComponent extends FacetRangeComponent {

  selectedFilter: Filter;

  selectedFilterField = new FormControl();

  selectId: string = 'facet-range-quick-select';

  @Input() blockId: string;

  constructor(protected filtersService: FacetService,
              private translator: TranslateService,
              htmlUtils: HtmlUtilsService){
    super(filtersService, htmlUtils, translator);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.filterBlock.childFilterBlocks.forEach(childBlock => {
      const findResult = childBlock.filters.find(filter => filter.selected);
      if (findResult){
        this.selectedFilter = findResult;
      }
    });
    this.selectedFilterField.setValue(this.selectedFilter);
    this.selectedFilterField.valueChanges.subscribe((filter: Filter) =>{
      if (filter){
        this.filtersService.cleanGroup(filter.field);
        filter.selected = true;
        //this.filtersService.navigateByFilters();// select Biblioteka Narodowa
      }
    });
  }
}
